import script from "./SlideTransition.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideTransition.vue?vue&type=script&lang=ts&setup=true"

import "./SlideTransition.vue?vue&type=style&index=0&id=656b11be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656b11be"]])

export default __exports__